package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.styles.DateLabelStyle
import io.horion.cv.styles.DateRangeContainerStyle
import io.horion.cv.styles.DateSectionStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.px

@Composable
fun DateRangeSelector(
    startMonth: String,
    startYear: String,
    endMonth: String,
    endYear: String,
    isOngoing: Boolean,
    onStartMonthChange: (String) -> Unit,
    onStartYearChange: (String) -> Unit,
    onEndMonthChange: (String) -> Unit,
    onEndYearChange: (String) -> Unit,
    onOngoingChange: (Boolean) -> Unit,
    modifier: Modifier = Modifier,
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val labelColor = if (isDark) Colors.White else Colors.Primary

    Column(
        modifier = DateRangeContainerStyle.toModifier().then(modifier)
    ) {
        // Date de début
        Column(
            modifier = DateSectionStyle.toModifier()
        ) {
            SpanText(
                text = "Date de début",
                modifier = DateLabelStyle.toModifier()
                    .color(labelColor)
                    .fontFamily(INTER)
                    .fontWeight(FontWeight.Light)
            )
            DateSelector(
                label = "",
                month = startMonth,
                year = startYear,
                onMonthChange = onStartMonthChange,
                onYearChange = onStartYearChange,
                modifier = Modifier.fillMaxWidth()
            )
        }

        // Date de fin
        Column(
            modifier = DateSectionStyle.toModifier()
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                SpanText(
                    text = "Date de fin",
                    modifier = DateLabelStyle.toModifier()
                        .color(labelColor)
                        .fontFamily(INTER)
                        .fontWeight(FontWeight.Light)
                        .then(if (isOngoing) Modifier.opacity(0.4f) else Modifier)
                )

                CheckboxWithLabel(
                    checked = isOngoing,
                    label = "En cours",
                    onCheckedChange = onOngoingChange
                )
            }

            DateSelector(
                label = "",
                month = endMonth,
                year = endYear,
                onMonthChange = onEndMonthChange,
                onYearChange = onEndYearChange,
                disabled = isOngoing,
                modifier = Modifier
                    .fillMaxWidth()
                    .then(if (isOngoing) Modifier.opacity(0.4f) else Modifier)
            )
        }
    }
}